import { CdkScrollable } from '@angular/cdk/scrolling';

import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';

@Component({
    selector: 'app-catalogue-stats-dialog',
        standalone: true,
imports: [
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatDialogClose,
    TranslatePipe
],
    templateUrl: './catalogue-stats-dialog.component.html',
    styleUrl: './catalogue-stats-dialog.component.scss'
})
export class CatalogueStatsDialogComponent {
  stats: any;
  salesStatistics: any;
  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CatalogueStatsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastService: ToastService
  ) {
    this.salesStatistics = data.stats;
    const { total_sales, ...filteredStats } = this.salesStatistics;

    this.stats = Object.entries(filteredStats).map(([key, value]) => {
      const prefixedKey = `buyer_catalogue_stat_${key}`;
      const formattedLabel = prefixedKey;

      return {
        label: formattedLabel,
        value: value,
      };
    });
  }
  onClose() {
    this.dialogRef.close();
  }
}
